import React from 'react';

const DemandValidationContext = React.createContext(null);
export const DemandValidationProvider = DemandValidationContext.Provider;
export default DemandValidationContext;